import React, { useEffect } from 'react';

import { AdapterDayjs, Loader, LocalizationProvider, Toast } from 'components';
import { useAuth, useOrganization } from 'hooks';

import { SupportChat } from './SupportChat';

import {
  RouterOutlet,
  SnackbarProvider,
  createGlobalStyle,
  cssResetStyles,
  useSelector,
} from 'third-party';

import { useSettings } from 'modules/setting';

import { appSelectors } from 'selectors';

import { TourContainer, useCheckTour } from 'utils/tour';

const GlobalStyle = createGlobalStyle`
  ${cssResetStyles}
 

  html, body {
    height: 100%;
    font-family: 'Inter';
  }

  input::-ms-reveal { display: none; }

  #root {
    display: flex;
    height: 100%;
  }
`;

export const MainContainer = () => {
  return (
    <TourContainer>
      <SnackbarProvider
        anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        Components={{
          error: Toast,
          success: Toast,
          warning: Toast,
          info: Toast,
        }}
      >
        <GlobalStyle />
        <RouterOutlet />
      </SnackbarProvider>
    </TourContainer>
  );
};

export const AppContainer = () => {
  const isAppLoaded = useSelector(appSelectors.isAppLoaded);
  const organizationId = useSelector(appSelectors.organizationId);

  useOrganization();
  useCheckTour();
  useAuth();

  const { loadSettings } = useSettings();

  useEffect(() => {
    if (organizationId) {
      loadSettings();
    }
  }, [loadSettings, organizationId]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {!isAppLoaded ? <Loader /> : <RouterOutlet />}
      <SupportChat />
    </LocalizationProvider>
  );
};
